// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yp-1";
export var printerIcon = "_yp-0";